/**
* This is the starting month of a cropping year, expressed in the [1..12] range
*/
export const CropYearStartMonth = 8

export class CropYear {


    static getYearFromDate(date: Date): number {

        let m = date.getMonth() + 1;


        if (m >= CropYearStartMonth) {
            return date.getFullYear() + 1;
        }

        return date.getFullYear();

    }

    static getClosestPreviousStartDate(date: Date): Date {

        var m = date.getMonth() + 1;

        var year = date.getFullYear();

        if (m < CropYearStartMonth) {
            year--;
        }

        return new Date(year, CropYearStartMonth - 1, 1);
    }

    static getClosestNextEndDate(date: Date): Date {

        var m = date.getMonth() + 1;

        var year = date.getFullYear();

        if (m >= CropYearStartMonth) {
            year++;
        }

        return (new Date(year, CropYearStartMonth - 1, 1)).addDays(-1);
    }

    static getDateInYear(date: Date, year: number, start: boolean): Date {

        if (start) {
            if ((1 + date.getMonth()) >= CropYearStartMonth) year--
        }

        return new Date(year, date.getMonth(), date.getDate());

    }

    static getYearStart(year: number) {
        return new Date(year - 1, CropYearStartMonth - 1, 1)
    }

    static getYearEnd(year: number) {
        return (new Date(year, CropYearStartMonth - 1, 1)).addDays(-1)
    }


    private _yearId: number;

    private _startDate: Date;
    private _endDate: Date;

    constructor(yearId: number) {

        this._yearId = yearId;

        this._startDate = CropYear.getYearStart(yearId)
        this._endDate = CropYear.getYearEnd(yearId)

    }

    get YearId(): number {
        return this._yearId;
    }

    get Year(): number {
        return this._yearId;
    }

    get StartDate(): Date {
        return this._startDate;
    }

    get EndDate(): Date {
        return this._endDate;
    }

}
